import { render, staticRenderFns } from "./ReviewMeetingNotes.vue?vue&type=template&id=2c8c3045&"
import script from "./ReviewMeetingNotes.vue?vue&type=script&lang=ts&"
export * from "./ReviewMeetingNotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports